export class Constants {
    public static ULTIMO:string = "31";
}

const XML_ENDING:string = ".xml";

export {
  XML_ENDING
}
